import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Button } from "@mui/material";
import catPaw from "../../assets/images/catPaw.svg";

const pawAnimation = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -60%) scale(1.2);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
`;

export const CatButton = styled(Button)({
  position: "relative",
  overflow: "hidden",

  "&::before": {
    content: '""',
    position: "absolute",
    left: "50%",
    top: "50%",
    width: 20,
    height: 20,
    backgroundImage: `url(${catPaw})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    transform: "translate(-50%, -50%)",
    opacity: 0,
    pointerEvents: "none",
  },

  "&:hover::before": {
    animation: `${pawAnimation} 0.2s ease-in-out forwards`,
  },
  "&:active::before": {
    animation: "none",
    transform: "translate(-50%, -50%) scale(0.8)",
    opacity: 1,
  },
});
